import React from 'react'

export const SwitchCase = ({ children, value }: any) => <>{children[value]}</>

SwitchCase.displayName = 'SwitchCase'
